<section style="width: 100%; overflow-x: hidden">
  <div
    class="d-flex justify-content-center align-items-center icon-header"
  >
    <mat-icon [color]="isDefault() ? 'primary' : 'warn'">
      {{isDefault() ? 'info' : 'warning'}}
    </mat-icon>
  </div>
  <h1 mat-dialog-title class="text-center">
    {{title}}
  </h1>
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-center">
    <button *ngIf="cancel" mat-button color="warn" (click)="cancelAction()">{{cancel}}</button>
    <button mat-button color="primary" (click)="confirmAction()" cdkFocusInitial>{{confirm}}</button>
  </div>
</section>
